import type { NextPage } from "next"

import PasswordAndSecret from "@features/generators/password-and-secret"

import Page from "@shared/ui/page"

const PasswordAndSecretGeneratorPage: NextPage = () => {
  return (
    <Page title={"Password and Secret"}>
      <PasswordAndSecret />
    </Page>
  )
}

export default PasswordAndSecretGeneratorPage
